<EIPAutoComplete TextField="projectDescription" ValueField="projectCode" WaterMarkText="Project Name"
  setId="projectListId" ShowTextValueField='Y' [IsCascading]='true'>
</EIPAutoComplete>

<!-- <div formArrayName="Elements" *ngFor="let other of personalForm.get('other').controls; let i = index" class="form-group">
    
          
  <div class="col"  [formGroupName]="i">
    <mat-form-field style="width: 100%;">
      <mat-label id="lblProjectCode">{{DE_Description}}</mat-label>
      <EIPAutoComplete TextField="DE_Description" ValueField="DE_Description" WaterMarkText="{{DE_Description}}"
        setId="DED_Id" ShowTextValueField='Y' [IsCascading]='true'>
      </EIPAutoComplete>
    </mat-form-field>
  </div> 
</div> -->